module.exports = __webpack_public_path__ + "static/media/27.97998859.jpg";